import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import TextInput from "../components/ui/Input/TextInput";
import styles from "../components/EntityAddUpdateForm/EntityAddUpdateForm.module.css";

const ResetPassword: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("k") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

const [loading, setLoading] = useState(false);

const handleSubmit = async (e: React.FormEvent) => {
e.preventDefault();
setErrorMessage(null);
setSuccessMessage(null);

if (!token) {
    setErrorMessage("Invalid or missing reset token. Please request a new reset link.");
    return;
}

if (password !== confirmPassword) {
    setErrorMessage("Passwords do not match.");
    return;
}

try {
    setLoading(true);
    const response = await fetch(`${import.meta.env.VITE_API_URL}/auth/reset-password`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, password, confirm_password: confirmPassword }),
    });

    const result = await response.json();

    if (result?.success) {
    setSuccessMessage("Password reset successfully!");
    setTimeout(() => navigate("/login", { state: { fromPasswordReset: true } }), 2500);
    } else {
    const raw = result?.errors?.length
        ? result.errors.map((e: any) => Object.values(e).join(", ")).join(", ")
        : result?.message || "Failed to reset password.";
    setErrorMessage(raw.replace(/^Error in [\w\s]+:\s*/i, ""));
    }
} catch (err) {
    setErrorMessage("Something went wrong. Please try again.");
} finally {
    setLoading(false);
}
};

  return (
    <div className="page-wrapper-columnwise">
      <div className="content-columnwise">
        <div className="center-container">
          <form onSubmit={handleSubmit} className={styles.entityChangePasswordForm}>
            <h2 className="form-title">Reset Password</h2>
            <h5>Enter your new password</h5>

            <TextInput
              label="New Password"
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => { setErrorMessage(null); setSuccessMessage(null); setPassword(e.target.value); }}
            />
            <TextInput
              label="Confirm Password"
              type="password"
              placeholder="Confirm Password"
              value={confirmPassword}
              onChange={(e) => { setErrorMessage(null); setSuccessMessage(null); setConfirmPassword(e.target.value); }}
            />

            {successMessage && <p className="success-message">{successMessage}</p>}
            {errorMessage && <p className="error-message">{errorMessage}</p>}

            <div className={styles.buttonContainer}>
              <button type="submit" className={styles.entityAddUpdateForm__submitbtn} disabled={loading}>
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;